import Ext from "Ext";
import messageResource from "../../../messageResource";
import HierarchySelectorSelectionHelper from "./at_hierarchy_selector_selection_helper";
import GroupType from "../../../enums/GroupType";
import {TimeZoneGroupValidatorStrategy, UserGroupValidatorStrategy} from "../../../util/GroupValidatorStrategy";
import {userComparator} from "../../../usersSelector/user_group_selector_util";
import {escapeHtmlSymbols, concatStr} from "../../../atUtils";

const SimpleUsersAndGroupsSelectionHelper = Ext.extend(HierarchySelectorSelectionHelper, {

    userSingularFormKey: "users_selector.user.singular",
    disabledUserKey: "users_selector.disabled",
    usersWithoutGroupKey: "users_selector.users_without_user_group_label",
    isNeededInformationAboutDisabledUsers: true,
    userSelectorGroupsStrategy: null,
    prefixTextForGroupsKey : null,
    pleaseSelectMessageKey: "users_selector.no_users_selected",
    userGroupMessageKey: "common.user_group",
    timeZoneGroupMessageKey: "common.time_zone.group",
    viewerId: null,


    getDescription: function(selection, dropdownButtonId) {
        var groups = selection.getFirstLevel();
        var users = selection.getSecondLevel();
        var type = selection.groupType;
        var validatorGroupStrategy = type == GroupType.TIME_ZONE_GROUP ? new TimeZoneGroupValidatorStrategy() : new UserGroupValidatorStrategy();
        if ((groups.length == 0) && (users.length == 0)) {
            return this.getMessage(this.pleaseSelectMessageKey);
        } else if ((groups.length + users.length) == 1) {
            var isSingleGroupSelected = (groups.length == 1);
            return this.getSingleItemText((isSingleGroupSelected ? groups : users)[0], isSingleGroupSelected, validatorGroupStrategy);
        } else {
            return this.getShortDescriptionForUsersAndGroups(groups, users, dropdownButtonId, type);
        }
    },

    getSingleItemText: function (item, isGroup, strategy) {
        var text = "";
        if (isGroup) {
            text += (strategy.isNullGroup(item)) ?
                    this.getMessage(this.usersWithoutGroupKey) :
                    escapeHtmlSymbols(item.getName());
        } else {
            var nounMsg = this.getMessage(this.itemNounSingularKey);
            if (!Ext.isEmpty(nounMsg)) {
                text += nounMsg + " ";
            }
            var formattedUserName = ( this.viewerId === item.id) ? 
                                    messageResource.getMessage("usersselector.me") : 
                                    escapeHtmlSymbols( this.formatUserNameInfo(item) );
            text += formattedUserName;
        }

        if (this.showSingleItemInactiveText && !isGroup && !item.isActive()) {
            text += " " + this.getMessage(this.inactiveSingleItemTextKey);
        }
        return text;
    },

    getSingleGroupTextKey: function(groupType){
       return groupType == GroupType.USER_GROUP ?  this.userGroupMessageKey : this.timeZoneGroupMessageKey;
    },

    getMultipleGroupTextKey: function(groupType){
        return  this.getSingleGroupTextKey(groupType) + "s";
    },

    getShortDescriptionForUsersAndGroups: function(groups, users, dropdownButtonId, groupType) {
        var result = "";
        var isGroupsPresent = (groups.length != 0);
        var isUsersPresent = (users.length != 0);
        if (isGroupsPresent) {
            if(this.prefixTextForGroupsKey)
                result += this.getMessage(this.prefixTextForGroupsKey) + " ";
            result += groups.length + " ";
            result += (groups.length == 1) ? this.getMessage(this.getSingleGroupTextKey(groupType)) : this.getMessage(this.getMultipleGroupTextKey(groupType));
            if (isUsersPresent) {
                if (dropdownButtonId) {
                    result = this.wrapTextByTitleSpans(result, dropdownButtonId, true);
                }
                result += " & ";
            }
        }
        if (isUsersPresent) {
            var itemNoun;
            var inactiveText = "";
            var subResult = "";

            if (users.length == 1) {
                itemNoun = this.getMessage(this.userSingularFormKey);
                inactiveText = (!this.isNeededInformationAboutDisabledUsers || users[0].isActive()) ? "" :
                               " " + this.getMessage(this.disabledUserKey);
            } else {
                itemNoun = this.getMessage(this.itemNounPluralKey);
                if (this.isNeededInformationAboutDisabledUsers) {
                    var inactiveCount = 0;

                    for (var i = 0; i < users.length; i++) {
                        if (!users[i].isActive()) {
                            ++inactiveCount;
                        }
                    }
                }
            }

            subResult += users.length + " ";
            subResult += itemNoun + inactiveText;

            if (dropdownButtonId && isGroupsPresent) {
                subResult = this.wrapTextByTitleSpans(subResult, dropdownButtonId, false);
            }
            result += subResult;
        }
        return result;
    },

    getCertainEntityList: function(selection, isForGroup) {
        var context = this;
        if (isForGroup) {
            return this.getListDescription(selection.getFirstLevel(), function(item) {return context.getListDescriptionItemForGroup(item)},
                                           selection.groupType == GroupType.TIME_ZONE_GROUP ? new TimeZoneGroupValidatorStrategy().getComparator() : new UserGroupValidatorStrategy().getComparator() , this.getMessage(this.getMultipleGroupTextKey(selection.groupType)));
        } else {
            return this.getListDescription(selection.getSecondLevel(), function(item) {return context.getListDescriptionItemForUser(item)}, userComparator);
        }
    },

    getListDescriptionItemForUser : function (user) {
        return concatStr(this.formatUserNameInfo(user), this.getListDescriptionItemStatus( user ), " ");
    },

    getListDescriptionItemForGroup: function(group) {
        return group.name;
    },

    getListDescriptionItemStatus : function ( user ) {
        if( !user.isActive() ) {
            return this.getMessage(this.disabledUserKey);
        }
    },

    formatUserNameInfo: function ( user ) {
        // not polymorphic. if in future we have more than 2 variants, how to format user name in selectors, we should use strategy here.
        return user.formatNameLFM();
    },

    setUserSelectorGroupsStrategy: function (userSelectorGroupsStrategy) {
        this.userSelectorGroupsStrategy = userSelectorGroupsStrategy;
    }

});

export default SimpleUsersAndGroupsSelectionHelper;


// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/selectionHelpers/simple_users_and_groups_selection_helper.js